import theme from "../themConfig";

export const boxes = [
  {
    icon: "folder",
    text: "Files",
    cantidad: 34,
    color: theme.palette.secondary.main,
  },
  {
    icon: "account_balance",
    text: "Places",
    cantidad: 20,
    color: theme.palette.info.main,
  },
  {
    icon: "assignment_ind",
    text: "Assigments",
    cantidad: 10,
    color: theme.palette.success.main,
  },
  {
    icon: "calendar_today",
    text: "Calendar",
    cantidad: 12,
    color: theme.palette.error.main,
  },
];
